export abstract class StorageService {
  abstract get(key: string): string | null;
  abstract set(key: string, value: string): void;
}